import React from 'react';
import { useDispatch } from 'react-redux';
import { actions, useSelector } from '../store';
import css from './MediaConstraintSetup.module.scss';
import Toggle from './Toggle';

export default function MediaConstraintSetup() {
    const mediaConstraints = useSelector(s => s.janus.mediaConstraint)
    const dispatch = useDispatch()

    function input(prop: keyof MediaTrackConstraintSet, label: string, type: string = 'text', inputProps?: React.InputHTMLAttributes<HTMLInputElement>) {
        return <label>{label}
            <div>
                <input type={type} value={String(mediaConstraints[prop])}
                    onChange={(e) => {
                        const numberValue = parseInt(e.currentTarget.value)
                        dispatch(actions.configureMediaConstraints({ ...mediaConstraints, [prop]: numberValue}))
                    }} {...inputProps} />
            </div>
        </label>
    }

    function toggle(prop: keyof MediaTrackConstraintSet, label: string) {
        return <Toggle className={css.toggle} value={Boolean(mediaConstraints[prop])} onChange={(value) => dispatch(actions.configureMediaConstraints({...mediaConstraints, [prop]: value}))}>{label}</Toggle>
    }

    return (
        <div className={css.mediaConstraintsContainer}>
            <div className={css.audioQualityContainer}>
                {input('channelCount', 'Channels', 'number', { min: 0, max: 2, step: 1})}
                {input('sampleRate', 'Sampling Rate', 'number')}
                {input('sampleSize', 'Bit Depth', 'number', { min: 8, max: 16, step: 8})}
            </div>
            {toggle('autoGainControl', 'Auto Gain Control')}
            {toggle('echoCancellation', 'Echo Cancellation')}
            {toggle('noiseSuppression', 'Noise Supression')}
        </div>
    )
}
